// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Goal ends the workflow — never show a bottom/source connection dot. */
.react-flow__node-goal .react-flow__handle-bottom,
.react-flow__node-goal .react-flow__handle-source {
  display: none !important;
  pointer-events: none !important;
  opacity: 0 !important;
  width: 0 !important;
  height: 0 !important;
  min-width: 0 !important;
  min-height: 0 !important;
  border: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/outbound/WorkflowCanvas.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;;EAEE,wBAAwB;EACxB,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;AACzB","sourcesContent":["/* Goal ends the workflow — never show a bottom/source connection dot. */\n.react-flow__node-goal .react-flow__handle-bottom,\n.react-flow__node-goal .react-flow__handle-source {\n  display: none !important;\n  pointer-events: none !important;\n  opacity: 0 !important;\n  width: 0 !important;\n  height: 0 !important;\n  min-width: 0 !important;\n  min-height: 0 !important;\n  border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
